import { render, staticRenderFns } from "./CampaignPerformancesAdsManagerMain.vue?vue&type=template&id=7229b0de&scoped=true&"
import script from "./CampaignPerformancesAdsManagerMain.vue?vue&type=script&lang=ts&"
export * from "./CampaignPerformancesAdsManagerMain.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignPerformancesAdsManagerMain.vue?vue&type=style&index=0&id=7229b0de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7229b0de",
  null
  
)

export default component.exports